<template>
  <v-menu max-width="256" v-model="shown" :close-on-click="false" :close-on-content-click="false" offset-y close-delay="300" nudge-bottom='8' bottom open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <slot :attrs="attrs" :on="on"></slot>
    </template>
    <div style="width: 256px; background-color: white;">
      <div style="width: 100%;height: 8px;" :style="getErrorColorStyle"></div>
      <div style="padding: 8px;">
        <div style="display: flex;justify-content: end">
          <v-icon @click="shown=false" small>{{ closeIcon }}</v-icon>
        </div>
        <div style="padding: 4px;display: flex;padding-right: 32px;">
          <v-icon color="error" large>{{ errorIcon }}</v-icon>
          <TextBody style="margin-left: 16px" :style="getErrorTextColorStyle">
            {{ message ? "Es ist ein Fehler aufgetreten: \n "+ message : t$(".message") }}
          </TextBody>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mdiWindowClose} from "@mdi/js";
import {mdiCloseCircle} from "@mdi/js";
import THEME from "constants/theme";
import TextBody from "components/UI/TextBody.vue";
import useTranslate from "features/common/translate/concerns/useTranslate";

const errorColor = THEME.colors.light.error;

export default defineComponent({
  name: "ErrorPopup",
  components: {TextBody},
  props: {
    message: {type: String},
  },
  computed: {
    getErrorColorStyle() {
      return {
        backgroundColor: errorColor,
      };
    },
    getErrorTextColorStyle(){
      return {
        color: errorColor,
      };
    },
    closeIcon() {
      return mdiWindowClose;
    },
    errorIcon() {
      return mdiCloseCircle;
    },
  },
  data: () => ({
    shown: false,
  }),
  setup() {
    const {t$} = useTranslate("components.error_popup");
    return {
      t$
    };
  },
});
</script>
